import React from "react";
import "./exteriorCleaning.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
// adjust image path if required

export default function ExteriorCleaning() {
  return (
    <>
    <Helmet>
      <title>Best Exterior Car Cleaning Service in Palwal</title>
      <meta
        name="description"
        content="Keep your car looking brand new with professional exterior car cleaning service at AutoCare in Palwal. We offer premium car repair & detailing services for complete exterior shine and protection."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/exterior-cleaning"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT CONTENT */}
        <div className="textContent">
          <h1>Best Exterior Car Cleaning Service in Palwal</h1>

          <p>
            Keep your car looking brand new with
            <strong> professional exterior car cleaning service</strong> at
            <span className="highlight"> AutoCare</span>.
            We are a reliable <span className="highlight">Auto Care in Palwal</span>
            offering premium <strong>car repair & detailing services</strong>
            for complete exterior shine and protection.
          </p>

          <h2>What is Exterior Car Cleaning?</h2>
          <p>
            Exterior car cleaning removes dirt, mud, dust, road grime,
            and pollutants from your car’s body, wheels, and glass,
            restoring shine and protecting the paint surface.
          </p>

          <h2>Benefits of Exterior Car Cleaning</h2>
          <ul>
            <li>Removes stubborn dirt & contaminants</li>
            <li>Restores paint shine & gloss</li>
            <li>Protects paint from long-term damage</li>
            <li>Keeps wheels & tyres clean</li>
            <li>Improves overall car appearance</li>
          </ul>

          <h2>Why Choose AutoCare for Exterior Cleaning?</h2>
          <ul>
            <li>One of the <span className="highlight">best exterior car cleaning services in Palwal</span></li>
            <li>High-quality shampoos & cleaning equipment</li>
            <li>Scratch-safe washing techniques</li>
            <li>Affordable pricing & fast service</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span> for car repair</li>
          </ul>

          <h2>Book Exterior Car Cleaning Near You</h2>
          <p>
            Searching for the <span className="highlight">best exterior car cleaning near me</span>?
            Choose <strong>AutoCare</strong> for professional results,
            safe washing, and long-lasting shine.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Exterior Cleaning
            </Link>
          </button>
        </div>

        {/* IMAGE CONTENT */}
        <div className="imageContent">
          <img
            src="/carServiceImages/Exterior Cleaning.webp"
            alt="Best Exterior Car Cleaning Service in Palwal by AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
